// extracted by mini-css-extract-plugin
export default {"btnBox":"ButtonTransparent_btnBox__XmlUi"};